
import Seo from '../../components/Seo';
const DOTS = (
  <span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>
);

const CHK = (
  <svg aria-hidden="true" className="chk" viewBox="0 0 16 16"><path fill="none" stroke="#007A6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg>
);

export default function TeamManagementPage() {
  
  return (
    <>
      <Seo title="Team Management — Roles, Permissions & Org Hierarchy | TeamGrid™" description="Roles, departments and reporting lines in one place. Set who sees what once, and every dashboard, report and export respects it. Org chart stays current." />
      <header className="fh">
        <div className="fh-grid">
          <div className="fh-copy">
            <span className="hero-badge"><img className="mark" src="/assets/mark-teamgrid.svg" alt="" />Team Organization <span className="arr">›</span></span>
            <h1 style={{fontSize: '52px', lineHeight: '57px', letterSpacing: '-2.1px', fontWeight: '700', color: 'var(--ink-hero)', marginBottom: '26px', maxWidth: '760px'}}>One org chart,<br /><span style={{color: '#a9aab3'}}>every permission clear</span></h1>
            <p style={{maxWidth: '620px', marginBottom: '26px', fontSize: '17px', lineHeight: '26px', color: 'var(--ink-soft)'}}>Roles, departments and reporting lines in one place. Set who sees what once, and every report, dashboard and export respects it from then on.</p>
            <ul className="hero-checks">
              <li>{CHK}<span><b>Member profiles.</b> Role, department and reporting line on one record.</span></li>
              <li>{CHK}<span><b>Permission controls.</b> Granular access to data and to features.</span></li>
              <li>{CHK}<span><b>Org hierarchy.</b> A visual chart with real reporting lines.</span></li>
            </ul>
            <div className="hero-cta-row">
              <a className="btn-primary" href="/register">Build your team free</a>
              <span className="hero-cta-note">7-day free trial.<br />No credit card.</span>
            </div>
          </div>
          <div className="fh-vis">
            <div className="frame">
              <div className="frame-h">{DOTS}TEAM DIRECTORY — 32 MEMBERS · 5 DEPARTMENTS</div>
              <div className="anlist" style={{paddingBottom: '8px'}}>
                <div className="ancard">
                  <span className="aico" style={{background: '#2DBDB8', color: '#fff', fontSize: '12px', fontWeight: 800}}>RS</span>
                  <span><span className="at" style={{color: '#007A6E'}}>ADMIN · ENGINEERING</span><span className="am"><b>Ritu Shah</b> · reports to Owner · org-wide access</span></span>
                </div>
                <div className="ancard">
                  <span className="aico" style={{background: '#8B75D7', color: '#fff', fontSize: '12px', fontWeight: 800}}>MK</span>
                  <span><span className="at" style={{color: '#6C59A6'}}>MANAGER · DESIGN</span><span className="am"><b>Manav Kapoor</b> · 4 reports · team data only</span></span>
                </div>
              </div>
              <div className="applist" style={{padding: '12px 18px 16px', borderTop: '1px solid var(--line-soft)'}}>
                <span className="ap">Owner<span className="bar"><b style={{width: '6%', background: '#007A6E'}}></b></span><span className="pc">1</span></span>
                <span className="ap">Admin<span className="bar"><b style={{width: '16%', background: '#469FD8'}}></b></span><span className="pc">3</span></span>
                <span className="ap">Manager<span className="bar"><b style={{width: '30%', background: '#8B75D7'}}></b></span><span className="pc">6</span></span>
                <span className="ap">Member<span className="bar"><b style={{width: '100%', background: '#F2A73A'}}></b></span><span className="pc">22</span></span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="sect" style={{paddingTop: '8px'}}>
        <div className="container">
          <h2 className="sect-h2">Structure your team<br /><span className="dim">once, properly</span></h2>
          <p className="sect-sub">Admins get hierarchy, permissions, visibility rules and reporting. Everyone else just gets the right view.</p>

          <div className="frow">
            <div className="fr-copy">
              <span className="fl" style={{color: '#2DBDB8'}}>MEMBER PROFILES</span>
              <h3>Everyone in one record, not five spreadsheets</h3>
              <p className="fd">Name, email, role, department and who they report to, held together. Change a role once and the org chart, permissions and reports all follow.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Complete profile per member, kept current</li>
                <li><span className="sarr">→</span>Departments and positions defined once</li>
                <li><span className="sarr">→</span>Reporting structure attached to the person</li>
              </ul>
            </div>
            <div className="frame">
              <div className="frame-h">{DOTS}TEAM MANAGEMENT — 32 MEMBERS · 23 POSITIONS</div>
              <div className="anlist">
                <div className="ancard">
                  <span className="aico" style={{background: '#34A851', color: '#fff', fontSize: '12px', fontWeight: 800}}>GP</span>
                  <span><span className="at" style={{color: '#34A851'}}>JUNIOR MARKETING DESIGNER</span><span className="am"><b>Gaurav Prajapati</b> · Marketing · active</span></span>
                </div>
                <div className="ancard">
                  <span className="aico" style={{background: '#6C59A6', color: '#fff', fontSize: '12px', fontWeight: 800}}>DD</span>
                  <span><span className="at" style={{color: '#6C59A6'}}>BUSINESS DEVELOPMENT</span><span className="am"><b>Deepika Dubey</b> · Sales · active</span></span>
                </div>
                <div className="ancard">
                  <span className="aico" style={{background: '#F2673A', color: '#fff', fontSize: '12px', fontWeight: 800}}>PJ</span>
                  <span><span className="at" style={{color: '#F2673A'}}>DIGITAL MARKETING</span><span className="am"><b>Purvi Joshi</b> · Marketing · active</span></span>
                </div>
              </div>
            </div>
          </div>

          <div className="frow rev">
            <div className="frame">
              <div className="frame-h">{DOTS}ACCESS BY ROLE</div>
              <div className="applist" style={{padding: '16px 18px'}}>
                <span className="ap">Owner<span className="bar"><b style={{width: '100%', background: '#2DBDB8'}}></b></span><span className="pc">All</span></span>
                <span className="ap">Admin<span className="bar"><b style={{width: '86%', background: '#469FD8'}}></b></span><span className="pc">Org</span></span>
                <span className="ap">Manager<span className="bar"><b style={{width: '54%', background: '#8B75D7'}}></b></span><span className="pc">Team</span></span>
                <span className="ap">Member<span className="bar"><b style={{width: '22%', background: '#F2A73A'}}></b></span><span className="pc">Self</span></span>
              </div>
            </div>
            <div className="fr-copy">
              <span className="fl" style={{color: '#469FD8'}}>PERMISSION CONTROLS</span>
              <h3>Access that matches the role, not the friendship</h3>
              <p className="fd">Set granular controls over data and features, then stop thinking about it. A manager sees their team. A member sees themselves. Nobody has to ask.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Feature-level and data-level controls</li>
                <li><span className="sarr">→</span>Visibility rules scoped to team or department</li>
                <li><span className="sarr">→</span>Reporting options set by the admin, not by luck</li>
              </ul>
            </div>
          </div>

          <div className="frow">
            <div className="fr-copy">
              <span className="fl" style={{color: '#8B75D7'}}>ORG HIERARCHY</span>
              <h3>Reporting lines you can actually see</h3>
              <p className="fd">A visual org chart built from the same records that drive permissions, so the picture on screen is the picture in the product. No parallel diagram to maintain.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Visual chart of teams and reporting lines</li>
                <li><span className="sarr">→</span>Analytics roll up along the hierarchy</li>
                <li><span className="sarr">→</span>Restructure once, everything downstream updates</li>
              </ul>
            </div>
            <div className="frame">
              <div className="frame-h">{DOTS}ORG CHART — HEADCOUNT BY DEPARTMENT</div>
              <div className="applist" style={{padding: '16px 18px'}}>
                <span className="ap">Engineering<span className="bar"><b style={{width: '88%', background: '#2DBDB8'}}></b></span><span className="pc">11</span></span>
                <span className="ap">Marketing<span className="bar"><b style={{width: '56%', background: '#34A851'}}></b></span><span className="pc">7</span></span>
                <span className="ap">Sales<span className="bar"><b style={{width: '48%', background: '#469FD8'}}></b></span><span className="pc">6</span></span>
                <span className="ap">Design<span className="bar"><b style={{width: '40%', background: '#6C59A6'}}></b></span><span className="pc">5</span></span>
                <span className="ap">Operations<span className="bar"><b style={{width: '24%', background: '#F2673A'}}></b></span><span className="pc">3</span></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sect" style={{paddingTop: '8px'}}>
        <div className="container">
          <div className="roi-cards" style={{marginTop: '0'}}>
            <div className="roi-card"><div className="rl">ADMIN CONTROLS</div><div className="rv">4</div><p>Hierarchy, permissions, visibility rules and reporting — all in one place.</p></div>
            <div className="roi-card"><div className="rl">POSITIONS</div><div className="rv">23</div><p>Defined once across 32 members in the sample workspace, applied everywhere.</p></div>
            <div className="roi-card"><div className="rl">ACCESS</div><div className="rv">Per role</div><p>Data and features gated by role, never by who remembered to ask.</p></div>
            <div className="roi-card"><div className="rl">SCREENSHOTS</div><div className="rv">0</div><p>Ever. Patterns, not people — measurement with dignity.</p></div>
          </div>
        </div>
      </section>

      <div className="container"><p className="roi-note" style={{margin: '0 0 4px'}}>*Sample workspace data shown. Your numbers come from your own team.</p></div>
      <div className="container"><div className="workswith"><span className="wl">WORKS BEST WITH</span><a href="/hrms">HRMS →</a><a href="/features/project-tracking">Project Tracking →</a></div></div>

      <section className="sect" style={{padding: '8px 0 24px'}}>
        <div className="container">
          <h2 className="sect-h2" style={{fontSize: '28px', lineHeight: '36px'}}>Common questions</h2>
          <div className="faq">
            <details><summary>What control do admins actually get?</summary><p>Four things: hierarchy controls, permission settings, visibility rules and reporting options. Together they decide how far analytics travel across teams and who can see them.</p></details>
            <details><summary>Can a manager be limited to their own team?</summary><p>Yes. Visibility rules scope a manager to their reporting line, so team analytics stay useful without opening the whole organization.</p></details>
            <details><summary>Does changing someone&apos;s role update everything else?</summary><p>Yes. Profiles, the org chart and permissions read from the same record, so one edit updates the chart, the access level and the reports that roll up.</p></details>
          </div>
        </div>
      </section>

      <section className="final" style={{paddingTop: '48px'}}>
        <div className="container-wide">
          <div className="final-band" style={{paddingBottom: '88px'}}>
            <h2>Give every role<br />exactly the right view</h2>
            <a className="btn-white" href="/register">Get started FREE</a>
          </div>
        </div>
      </section>
    </>
  );
}
